{
  "flaggedStacksPresenter": {
    "title": "Flagged Stacks",
    "columns": {
      "id": "ID",
      "hangar": "Hangar",
      "date": "Date"
    },
    "buttons": {
      "view": "View"
    }
  }
}
